import { render, staticRenderFns } from "./JourneyCapture.vue?vue&type=template&id=169d0e2b&scoped=true"
import script from "./JourneyCapture.vue?vue&type=script&lang=js"
export * from "./JourneyCapture.vue?vue&type=script&lang=js"
import style0 from "./JourneyCapture.vue?vue&type=style&index=0&id=169d0e2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169d0e2b",
  null
  
)

export default component.exports